{
  "es": {
    "subscription": {
      "customers": {
        "announcement": {
          "description": "Recibe una notificación cuando se publiquen nuevas novedades.",
          "label": "Novedades"
        },
        "question": {
          "description": "Recibe una notificación cuando se añadan nuevas preguntas en la sección de preguntas frecuentes.",
          "label": "Preguntas frecuentes"
        }
      },
      "employees": {
        "aftercare": {
          "description": "Recibe notificaciones relacionadas con incidencias y posventa.",
          "label": "Posventa"
        },
        "announcement": {
          "description": "Recibe una notificación cuando se publiquen nuevas novedades.",
          "label": "Novedades"
        },
        "decision": {
          "description": "Recibe notificaciones relacionadas con las decisiones.",
          "label": "Decisiones"
        },
        "document": {
          "description": "Recibe una notificación cuando se suban nuevos documentos.",
          "employee_create": {
            "description": "Recibe una notificación cuando otros empleados suban documentos.",
            "label": "Documentos de compañeros"
          },
          "label": "Documentos"
        },
        "email_conversation": {
          "description": "Recibe una notificación cuando se reenvíen correos a tus proyectos de Ziggu.",
          "label": "Reenvío de correo"
        },
        "export": {
          "description": "Recibe una notificación cuando se generen exportaciones.",
          "label": "Exportaciones"
        },
        "mention": {
          "description": "Recibe una notificación cuando un colega te mencione por tu nombre en una conversación.",
          "label": "Menciones"
        },
        "question": {
          "description": "Recibe una notificación cuando se añadan nuevas preguntas en la sección de preguntas frecuentes.",
          "label": "Preguntas frecuentes"
        },
        "survey": {
          "description": "Recibe notificaciones relacionadas con las encuestas.",
          "label": "Encuestas"
        },
        "ticket": {
          "description": "Recibe notificaciones relacionadas con las conversaciones.",
          "label": "Conversaciones"
        },
        "todo": {
          "description": "Recibe una notificación cuando te asignen como responsable de una tarea.",
          "label": "Asignaciones de tareas"
        }
      },
      "labels": {
        "email_preferences": "Mis preferencias de notificaciones por correo",
        "general_preferences": "Mis preferencias de notificaciones",
        "receiveEmailNotificationsAbout": "Recibir notificaciones por correo"
      }
    }
  }
}
